export default __webpack_public_path__ + "static/media/Q4.6ee9f738.jpg";